import { render, staticRenderFns } from "./ProtocolDialog.vue?vue&type=template&id=3de00ac8&scoped=true"
import script from "./ProtocolDialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProtocolDialog.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./ProtocolDialog.vue?vue&type=style&index=0&id=3de00ac8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3de00ac8",
  null
  
)

export default component.exports